export interface Order {
  userID: string;
  regular: string;
  shipments: [
    {
      width: string;
      height: string;
      length: string;
      weight: string;
      quantity: string;
      packaging: string;
      actualweight: number;
      chargeableweight: number;
      totalvolume: number;
    }
  ];
  shipmentpcs: number;
  shipmentweight: number;
  shipmentchargeableweight: number;
  shipmentvolume: number;
  intervals: string;
  transittime: string;
  shipmentready: Date;
  specialreq: string;
  pickup: string;
  shipperaddresses: Array<{}>;
  origin: string;
  delivery: string;
  consigneeaddresses: Array<{}>;
  destination: string;
  contact: {
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    companyname: string;
    taxnr: string;
  };
  gdpr: boolean;
  marketing: boolean;
  notifications: boolean;
  status: string;
  [key: string]: string | number | any;
}

export interface RequestFormState {
  activeStep: number;
  cargoDetails: number;
  serviceInfo: number;
  userDetails: number;
  shipperNumber: number;
  order: Order;
  userAccount: {};
  userFetched: boolean;
  loggedIn: boolean;
  [key: string]: string | number | any;
}
export interface RequestFormProps {
  t: any;
}

export const defaultRequestFormState: RequestFormState = {
  activeStep: 0,
  cargoDetails: 0,
  serviceInfo: 0,
  userDetails: 0,
  shipperNumber: 1,
  order: {
    userID: "",
    regular: "",
    shipments: [
      {
        width: "",
        height: "",
        length: "",
        weight: "",
        quantity: "",
        packaging: "",
        actualweight: 0,
        chargeableweight: 0,
        totalvolume: 0,
      },
    ],
    shipmentpcs: 0,
    shipmentweight: 0,
    shipmentchargeableweight: 0,
    shipmentvolume: 0,
    intervals: "",
    transittime: "",
    shipmentready: new Date(),
    specialreq: "",
    pickup: "",
    shipperaddresses: [{}],
    origin: "",
    delivery: "",
    consigneeaddresses: [{}],
    destination: "",
    contact: {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      companyname: "",
      taxnr: "",
    },
    gdpr: false,
    marketing: false,
    notifications: true,
    status: "processing",
  },
  userAccount: {},
  userFetched: false,
  loggedIn: false,
};
